import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import BackgroundVideo from '../components/video/background'
import classnames from 'classnames'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import ScrollIntoView from 'react-scroll-into-view'
import { mapHome, mapMetaData } from '../utils/mapper'
import { sortedServices } from '../utils/helpers'
import {
  fragCustomer,
  fragPost,
  fragStudy,
  fragCareer,
  fragService,
  fragVideo,
} from '../utils/fragments'

import identity from '../themes/default/brand/identity'
import { withStyles } from '@material-ui/core/styles'
import styles from '../styles/site'
import '../styles/transitions.css'

import MetaData from '../components/metadata'
import TextGradient from '../components/gradient'
import Cookie from '../components/cookie'

import down from '../img/icons/down.svg'
import map from '../img/icons/map.svg'
import time from '../img/icons/time.svg'
import info from '../img/icons/info.svg'

import taas from '../img/logos/taas_lg.png'
import fixed from '../img/logos/fixed_lg.png'

import InlineVideo from '../components/video/inline'
import Footer from '../components/footer'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { DarkRawTheme } from 'material-ui/styles'

class IndexPage extends React.Component {
  componentDidMount() {
    AOS.init({
      duration: 1500,
    })
  }

  componentDidUpdate() {
    AOS.refresh()
  }

  render() {
    const { classes } = this.props

    const metadata = mapMetaData(this.props.data.home)
    const home = mapHome(this.props.data)

    return (
      <div>
        <Cookie />
        <MetaData data={metadata} />
        <HomePoster content={home.hero} />

        <div
          id="sections"
          className={classes.frontMatter}
          style={{ top: '100vh' }}
        >
          <Lead lead={home.lead} />
          <Services services={home.services} />
          <Methodology methods={home.methods} method={home.method} />
          <Video video={home.video} />
          {home.body.map((item, index) => {
            switch (item.type) {
              case 'featured_blogs': {
                return <Blogs key={index} item={item} />
              }
              case 'featured_careers': {
                return <Careers key={index} item={item} />
              }
              case 'featured_clients': {
                return <Clients key={index} item={item} />
              }
            }
          })}
          <Footer policies={this.props.data.policies.edges} />
        </div>
      </div>
    )
  }
}

const HomePoster = withStyles(styles)(props => {
  const { classes, content, started } = props

  return (
    content && (
      <div className={classes.pinned}>
        <div className={classes.inner}>
          <BackgroundVideo
            urls={content.video_bg.urls}
            poster={content.video_bg.poster}
          />

          <div
            className={classnames(classes.centred, classes.front)}
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <div className={classes.frontOpener}>
              <img
                // fadeIn={false}
                src={content.logo.src}
                className={classes.frontLogo}
                alt="cloudThing logo"
              />
              <Hidden smDown>
                <Typography align="center" className={classes.frontStrap}>
                  {content.tagline.text}
                </Typography>
              </Hidden>
            </div>
          </div>
          <div className={classes.frontDown}>
            <ScrollIntoView selector="#lead">
              <img src={down} alt="See more icon" />
            </ScrollIntoView>
          </div>
        </div>
      </div>
    )
  )
})

const Lead = withStyles(styles)(props => {
  const { classes, lead } = props
  return (
    <div className={'leadA'} data-aos="fade-up" data-aos-once>
      <div id="lead" className={classes.lead}>
        <div className={classes.contents}>
          <div className={classes.centred}>
            <Grid container spacing={8}>
              <Grid item xs={12}>
                <Hidden smDown>
                  <Typography className={classes.leadSub}>
                    {lead.subtitle.text}
                  </Typography>
                </Hidden>
                <Typography variant="headline" className={classes.leadHead}>
                  <TextGradient
                    text={lead.title.text}
                    fromColor="#A8AD9B"
                    toColor="#00CDE0"
                    direction="left"
                  />
                </Typography>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  )
})

const Services = withStyles(styles)(props => {
  const { classes, services } = props

  return (
    <div className={'servicesA'}>
      <div className={classes.services}>
        <div className={classes.contents}>
          <div className={classes.centred} data-aos="fade-up" data-aos-once>
            <Grid container spacing={0}>
              {sortedServices(services).map((service, index) => {
                let LinkButton = props => (
                  <Link to={`service/${service.uid}`} {...props} />
                )
                return (
                  <Grid
                    key={index}
                    item
                    xs={12}
                    md={3}
                    className={classes.servicesItem}
                  >
                    <div className={classes.servicesContent}>
                      <div className={classes.servicesLogoWrapper}>
                        <img src={service.logo.src} alt={service.title.text} />
                      </div>
                      {service.title && (
                        <Typography
                          variant="headline"
                          className={classes.servicesHead}
                          gutterBottom
                        >
                          <TextGradient
                            text={service.title.text}
                            fromColor={identity[service.uid].from}
                            toColor={identity[service.uid].to}
                            direction="left"
                          />
                        </Typography>
                      )}

                      {service.subtitle && (
                        <Typography className={classes.servicesText}>
                          {service.subtitle.text}
                        </Typography>
                      )}
                    </div>
                    <div>
                      <Button
                        component={LinkButton}
                        className={classnames(
                          classes.servicesButton,
                          classes[`serviceButton_${service.uid}`]
                        )}
                        classes={{ label: classes.servicesButtonLabel }}
                      >
                        More
                        {/* <ChevronRight className={classes.rightIcon} /> */}
                      </Button>
                    </div>
                  </Grid>
                )
              })}
            </Grid>
          </div>
        </div>
      </div>
    </div>
  )
})

const Methodology = withStyles(styles)(props => {
  const { classes, method, methods } = props

  return (
    <div className={classes.methodology}>
      <div className={classes.contents}>
        <div className={classes.centred} data-aos="fade-up" data-aos-once>
          <Grid container spacing={40}>
            <Grid item xs={12}>
              <Typography variant="title" className={classes.methodologyTitle}>
                <TextGradient
                  text={method.title.text}
                  fromColor="#8645B3"
                  toColor="#89DEF4"
                  direction="left"
                />
              </Typography>
              <Typography paragraph className={classes.methodologySubtitle}>
                {method.subtitle.text}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <div className={classes.methodologyContainer}>
                {methods.map(m => {
                  let LinkButton = props => (
                    <Link to={`/method/${m.uid}`} {...props} />
                  )
                return (
                    <div
                      className={classnames(
                        classes.methodologyItem,
                        m.uid === 'ct-method-taas'
                          ? classes.methodologyTaas
                          : classes.methodologyFixed
                      )}
                    >
                      <div className={classes.methodologyContent}>
                        <div>
                          <img
                            src={m.uid === 'ct-method-taas' ? taas : fixed}
                          />
                          <Typography variant="title">
                            {m.title.text}
                          </Typography>
                          <Typography variant="subheading">
                            {m.subtitle.text}
                          </Typography>
                          <Button
                            component={LinkButton}
                            variant="outlined"
                            className={classes.methodologyButton}
                          >
                            More
                          </Button>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  )
})

const Video = withStyles(styles)(props => {
  const { classes, video } = props
  let LinkButton = props => <Link to={`/about`} {...props} />
  return (
    <div className={classes.featuredStudies}>
      <div className={classes.contents}>
        <div className={classes.centred} data-aos="fade-up" data-aos-once>
          <Grid container spacing={40}>
            <Grid item xs={12}>
              <Typography
                variant="title"
                className={classes.featuredStudiesHead}
              >
                <TextGradient
                  text={video.title.text}
                  fromColor="#8645B3"
                  toColor="#89DEF4"
                  direction="left"
                />
              </Typography>
              <Typography paragraph className={classes.featuredStudiesSub}>
                {video.subtitle.text}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <InlineVideo
                urls={video.videos.urls}
                poster={video.videos.poster}
              />
              <div className={classes.findOutMore}>
                <Button
                  component={LinkButton}
                  variant="outlined"
                  className={classnames(classes.findOutMoreButton)}
                >
                  FIND OUT MORE
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  )
})

const Careers = withStyles(styles)(props => {
  const { classes, item } = props
  const { primary, content } = item
  return (
    <div className={'careersA'}>
      <div className={classes.careers}>
        <div className={classes.contents}>
          <div className={classes.centred} data-aos="fade-up" data-aos-once>
            <Grid container spacing={40}>
              <Grid item xs={12}>
                {primary.title && (
                  <Typography variant="title" className={classes.careersHead}>
                    <TextGradient
                      text={primary.title.text}
                      fromColor="#ffffff"
                      toColor="#dfe0eb"
                      direction="left"
                    />
                  </Typography>
                )}

                {primary.subtitle && (
                  <Typography className={classes.careersSub} gutterBottom>
                    {primary.subtitle.text}
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Grid container spacing={40} className={classes.careerDetails}>
              {content.map((career, index) => {
                let LinkButton = props => <Link to={`/careers`} {...props} />
                return (
                  typeof career !== 'undefined' && (
                    <Grid key={index} item xs={12}>
                      <Typography
                        className={classes.careersRoleTitle}
                        gutterBottom
                      >
                        {career.role.text}
                      </Typography>
                      <Typography
                        className={classes.careersRoleDescription}
                        gutterBottom={true}
                      >
                        {career.description.text}
                        {/* <div
                          dangerouslySetInnerHTML={{
                            __html: career.description.html,
                          }}
                        /> */}
                      </Typography>
                      <div>
                        <img
                          src={map}
                          className={classes.careersIcon}
                          alt="#"
                        />
                        <Typography className={classes.careersText}>
                          {career.filter_location}
                        </Typography>
                      </div>
                      <div>
                        <img
                          src={time}
                          className={classes.careersIcon}
                          alt="#"
                        />
                        <Typography className={classes.careersText}>
                          {career.filter_type}
                        </Typography>
                      </div>
                      <div>
                        <img
                          src={info}
                          className={classes.careersIcon}
                          alt="#"
                        />
                        <Typography className={classes.careersText}>
                          {career.contact.text}
                        </Typography>
                      </div>
                      <Button
                        component={LinkButton}
                        className={classnames(
                          classes.careerLinkButton,
                          classes.careersContactLink
                        )}
                      >
                        More
                        {/* <ChevronRight className={classes.rightIcon} /> */}
                      </Button>
                    </Grid>
                  )
                )
              })}
            </Grid>
          </div>
        </div>
      </div>
    </div>
  )
})

const Blogs = withStyles(styles)(props => {
  const { classes, item } = props
  const { primary, content } = item

  return (
    <div className={classes.blog} data-aos="fade-up" data-aos-once>
      <div className={classes.contents}>
        <div className={classnames(classes.centred, classes.ç)}>
          <Grid container spacing={40}>
            <Grid item xs={12}>
              {primary.title && (
                <Typography variant="title" className={classes.blogHead}>
                  <TextGradient
                    text={primary.title.text}
                    fromColor="#8645B3"
                    toColor="#89DEF4"
                    direction="left"
                  />
                </Typography>
              )}
              {primary.subtitle && (
                <Typography paragraph className={classes.blogSub}>
                  {primary.subtitle.text}
                </Typography>
              )}
            </Grid>
            {content.map((blog, index) => {
              let LinkButton = props => (
                <Link to={`blog/${blog.uid}`} {...props} />
              )
              let first = index === 0
              return (
                typeof blog !== 'undefined' && (
                  <Grid
                    key={index}
                    item
                    xs={12}
                    md={first ? 12 : 6}
                    className={classes.blogHover}
                  >
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        md={first ? 6 : 12}
                        className={classnames(
                          first ? classes.blogItemImgPad : classes.blogItemNorm
                        )}
                      >
                        <div>
                          <img
                            src={blog.thumbnail.src}
                            style={{ position: 'relative', width: '100%' }}
                          />
                        </div>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={first ? 6 : 12}
                        className={classnames(
                          first ? classes.blogItemPad : classes.blogItemNorm
                        )}
                      >
                        <Grid container>
                          <Grid item xs={9} md={12}>
                            <Typography
                              variant="title"
                              gutterBottom
                              className={classes.blogItemTitle}
                            >
                              {blog.title.text}
                            </Typography>
                            {blog.author && (
                              <Typography
                                variant="caption"
                                className={classes.blogAuthor}
                              >
                                {blog.author.name.text}
                              </Typography>
                            )}
                            <Typography
                              variant="caption"
                              className={classes.blogDate}
                            >
                              {blog.published}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Typography className={classes.blogLead} gutterBottom>
                          {blog.lead.text}
                        </Typography>
                        <Button
                          component={LinkButton}
                          className={classes.postLinkButton}
                        >
                          Read more
                          {/* <ChevronRight className={classes.rightIcon} /> */}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                )
              )
            })}
          </Grid>
        </div>
      </div>
    </div>
  )
})

const Clients = withStyles(styles)(props => {
  const { classes, item } = props
  const { primary, content } = item

  return (
    <div className={'clientsA'}>
      <div className={classes.clients}>
        <div className={classes.contents}>
          <div className={classes.centred} data-aos="fade-up" data-aos-once>
            <Grid container spacing={40}>
              <Grid item xs={12}>
                {primary.title && (
                  <Typography variant="title" className={classes.clientsHead}>
                    <TextGradient
                      text={primary.title.text}
                      fromColor="#efefef"
                      toColor="#fff"
                      direction="left"
                    />
                  </Typography>
                )}
                {primary.subtitle && (
                  <Typography className={classes.clientsSub}>
                    {primary.subtitle.text}
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Grid
              container
              spacing={8}
              className={classes.clientsIcons}
              alignItems={'center'}
              direction={'row'}
            >
              {content &&
                content.map((customer, index) => {
                  return (
                    typeof customer !== 'undefined' && (
                      <Grid key={index}>
                        <img
                          src={customer.logo.src}
                          alt={customer.logo.alt}
                          className={classes.clientIconImg}
                        />
                      </Grid>
                    )
                  )
                })}
            </Grid>
          </div>
        </div>
      </div>
    </div>
  )
})

export default withStyles(styles)(IndexPage)

export const query = graphql`
  query homeQuery {
    home: prismicCtHome {
      uid
      data {
        lead_text {
          html
          text
        }
        lead_subtitle {
          html
          text
        }
        # logo {
        #   url
        # }
        logo {
          localFile {
            childImageSharp {
              original {
                src
              }
              sizes(maxWidth: 1200) {
                ...GatsbyImageSharpSizes
              }
            }
          }
          url
        }
        tagline {
          html
          text
        }
        method_title {
          text
        }
        method_subtitle {
          text
        }
        hero_videos {
          document {
            ...video
          }
        }
        featured_video_title {
          html
          text
        }
        featured_video_subtitle {
          html
          text
        }
        featured_video {
          document {
            ...video
          }
        }
        body {
          __typename
          ... on PrismicCtHomeBodyFeaturedBlogs {
            slice_type
            primary {
              title {
                html
                text
              }
              subtitle {
                html
                text
              }
            }
            items {
              blog {
                document {
                  ...post
                }
              }
            }
          }
          __typename
          ... on PrismicCtHomeBodyFeaturedCareers {
            slice_type
            primary {
              title {
                html
                text
              }
              subtitle {
                html
                text
              }
            }
            items {
              career {
                document {
                  ...career
                }
              }
            }
          }
          __typename
          ... on PrismicCtHomeBodyFeaturedClients {
            slice_type
            primary {
              title {
                html
                text
              }
              subtitle {
                html
                text
              }
            }
            items {
              customer {
                document {
                  ...customer
                }
              }
            }
          }
        }
        meta_title {
          text
        }
        meta_description {
          text
        }
        og_title {
          text
        }
        og_description {
          text
        }
        og_type {
          text
        }
      }
    }
    services: allPrismicCtService {
      edges {
        node {
          ...service
        }
      }
    }
    methods: allPrismicCtMethod {
      edges {
        node {
          uid
          ...method
        }
      }
    }

    policies: allPrismicCtDoc {
      edges {
        node {
          uid
          data {
            title {
              text
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js